import React from 'react';
import { MfaRecoveryCodesPanel } from '@/features/auth/components/AccountSecurity/MfaRecoveryCodesPanel';
import PageMeta from '@/shared/components/PageMeta';

export const AccountSecurity: React.FC = () => {
    return (
        <>
            <PageMeta title="Account Security" description="Manage your account security settings" />
            <div className="max-w-2xl mx-auto p-6 space-y-8">
                <h1 className="text-2xl font-semibold text-mp-foreground">
                    Account Security
                </h1>
                <MfaRecoveryCodesPanel />
            </div>
        </>
    );
};
